import {
  FETCH_HOMEWORKS,
  FETCH_HOMEWORK,
  SAVE_HOMEWORK,
  DELETE_HOMEWORK,
  LOADING_HOMEWORKS,
  FETCH_MY_HOMEWORKS,
  FETCH_HOMEWORK_ACCESS,
  CLEAN_AUTH
} from "../actions/type";

const INIT_STATE = {
  // teacher
  homeworks: [],
  homeworkMap: {},
  pagination: null,
  // student
  myHomeworks: [],
  isLoadingHomeworks: false,
  // { canAssign, canView, canAnswer }; null until the server has answered,
  // and nothing homework is shown until then
  access: null
};

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case FETCH_HOMEWORKS:
      return {
        ...state,
        homeworks: payload.homeworks,
        pagination: payload.pagination
      };

    // The list rows carry counts and the detail carries the roster, so a
    // saved homework is merged over what is already known about it
    case FETCH_HOMEWORK:
    case SAVE_HOMEWORK:
      if (!payload.homework || !payload.homework._id) {
        console.error("Invalid homework payload:", payload);
        return state;
      }
      return {
        ...state,
        homeworkMap: {
          ...state.homeworkMap,
          [payload.homework._id]: {
            ...state.homeworkMap[payload.homework._id],
            ...payload.homework
          }
        }
      };

    case DELETE_HOMEWORK: {
      const { [payload.homeworkId]: _removed, ...homeworkMap } =
        state.homeworkMap;

      return {
        ...state,
        homeworks: state.homeworks.filter(
          (homework) => homework._id !== payload.homeworkId
        ),
        homeworkMap
      };
    }

    case FETCH_MY_HOMEWORKS:
      return { ...state, myHomeworks: payload.homeworks };

    case LOADING_HOMEWORKS:
      return { ...state, isLoadingHomeworks: payload };

    case FETCH_HOMEWORK_ACCESS:
      return { ...state, access: payload.access };

    // Another account must not inherit the lists or the access of this one
    case CLEAN_AUTH:
      return { ...INIT_STATE };

    default:
      return state;
  }
};
